import { render, staticRenderFns } from "./readyPaymentErrorThh.vue?vue&type=template&id=213e25c4&scoped=true"
import script from "./readyPaymentErrorThh.vue?vue&type=script&lang=js"
export * from "./readyPaymentErrorThh.vue?vue&type=script&lang=js"
import style0 from "./readyPaymentErrorThh.vue?vue&type=style&index=0&id=213e25c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213e25c4",
  null
  
)

export default component.exports